import { render, staticRenderFns } from "./PowerByTestB.vue?vue&type=template&id=d0c0e832"
import script from "./PowerByTestB.vue?vue&type=script&lang=js"
export * from "./PowerByTestB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports